export default "<div class=\"bh-footer-container\">\n\t<div [innerHtml]='leftMessage'></div>\n\t<div [innerHtml]='rightMessage'></div>\n</div>"